import { z } from "zod/v4";

export const chatRoomTypeSchema = z.enum(["general", "custom", "squad", "direct", "coach_group"]);

export const memberAvatarPreviewSchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
});

export const chatRoomSchema = z.object({
	club_id: z.string().uuid(),
	created_at: z.coerce.date(),
	created_by: z.string().uuid(),
	// Present on the room list. Optional so a row written before these fields
	// still type-checks; the UI treats absence as empty.
	has_pending_invite: z.boolean().optional(),
	has_unread: z.boolean().optional(),
	id: z.string().uuid(),
	is_member: z.boolean(),
	last_message: z.string().nullable().optional(),
	last_message_at: z.coerce.date().nullable().optional(),
	member_avatar_previews: z.array(memberAvatarPreviewSchema).optional(),
	member_count: z.number().int(),
	name: z.string(),
	type: chatRoomTypeSchema,
	visibility: z.string().optional(),
});

export const chatRoomInviteSchema = z.object({
	chat_room_id: z.string(),
	club_id: z.string(),
	created_at: z.string(),
	id: z.string().uuid(),
	invitee_avatar_url: z.string().nullable().optional(),
	invitee_display_name: z.string(),
	invitee_id: z.string(),
	inviter_avatar_url: z.string().nullable().optional(),
	inviter_display_name: z.string(),
	inviter_id: z.string(),
	room_name: z.string(),
	status: z.string(),
});

export const roomInviteeSchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	id: z.string().uuid(),
	invite_status: z.enum(["pending", "accepted", "declined"]).optional(),
});

export const createChatRoomSchema = z.object({
	name: z.string().min(1, "Room name is required").max(50, "Room name too long"),
});

export const updateChatRoomSchema = createChatRoomSchema;

export const roomMemberSchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	joined_at: z.coerce.date(),
	user_id: z.string().uuid(),
});
